// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/qr-batch';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

const config = {
  fontFamily: `'ABeeZee', Arial, sans-serif`
};

export default config;
